import Stores from "./Stores";
import ViewStore from "./ViewStore";

export const STORES_ROUTE = "/stores";
export const ADD_STORE_ROUTE = STORES_ROUTE + "/new";
export const VIEW_STORE_ROUTE = STORES_ROUTE + "/view";

export const routes = [
    {
        path: STORES_ROUTE,
        component: Stores,
        exact: true
    },
    {
        path: ADD_STORE_ROUTE,
        component: ViewStore,
        exact: true
    },
    {
        path: VIEW_STORE_ROUTE+"/:id",
        component: ViewStore,
        exact: true
    }
];